import { render, staticRenderFns } from "./DeviceDescription.vue?vue&type=template&id=8dba99f8&"
import script from "./DeviceDescription.vue?vue&type=script&lang=ts&"
export * from "./DeviceDescription.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceDescription.vue?vue&type=style&index=0&id=8dba99f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports